import { Button, Dialog, DialogTitle, Tab, Tabs, styled } from '@mui/material';

export const StyleAiDialog = {
  Dialog: styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      maxWidth: '900px',
      backgroundColor: theme.palette.primary.main,
    },
  })),
  DialogTitle: styled(DialogTitle)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    // width: '100%',
    flexWrap: 'wrap',
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    color: theme.palette.primary.contrastText,
  })),
  SettingButton: styled(Button)(() => ({
    color: '#837300',
    backgroundColor: '#FDFACA',
    ':hover': { backgroundColor: '#FDFACA' },
    ':disabled': {
      backgroundColor: '#DBDEE1',
    },
  })),
  Tabs: styled(Tabs, {
    shouldForwardProp: prop => prop !== 'isMobile',
  })<{ isMobile: boolean }>(({ theme, isMobile }) => ({
    padding: `0px ${isMobile ? '0px' : theme.spacing(1)}`,
    '& .MuiTabs-flexContainer': {
      justifyContent: 'space-around',
      width: '100%',
      flexDirection: isMobile ? 'column' : 'row',
    },
    '& .MuiTab-root': {
      width: isMobile ? '99%' : '49%',
      maxWidth: 'none',
      minHeight: '80px',
      padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
      margin: isMobile ? '0px 0px 8px 0px!important' : '0px!important',
      borderRadius: isMobile ? '8px' : '8px 8px 0px 0px',
      justifyContent: 'left',
    },
    '& .MuiTab-root:first-of-type': {
      borderTop: '3px solid #CB7629',
      borderRight: '3px solid #CB7629',
      borderLeft: '3px solid #CB7629',
      background: '#FFB73D',
      boxShadow: '4px 4px 0px 0px #CB7129',
    },
    '& .MuiTab-root:nth-of-type(2)': {
      borderTop: '3px solid #00834C',
      borderRight: '3px solid #00834C',
      borderLeft: '3px solid #00834C',
      background: '#C8FAD1',
      boxShadow: '4px 4px 0px 0px #00834C',
    },
  })),
  DecoratedText: styled('span')(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '30px',
    minWidth: '30px',
    borderRadius: '4px',
    border: '1px solid #919EAB3D',
    background: '#FDFACA',
    color: '#FF7257',
    padding: '4px',
    margin: '4px',
  })),
  SubTabs: styled(Tabs, {
    shouldForwardProp: prop =>
      prop !== 'tabColor' &&
      prop !== 'activeTabColor' &&
      prop !== 'tabTextColor' &&
      prop !== 'activeTextColor',
  })<{
    tabColor: string;
    activeTabColor: string;
    tabTextColor: string;
    activeTextColor: string;
  }>(({ theme, tabColor, activeTabColor, tabTextColor, activeTextColor }) => ({
    position: 'relative',
    borderRadius: '3px',
    margin: `0px ${theme.spacing(1)}`,
    '&.MuiTabs-root': {
      minHeight: 'auto',
    },
    '& .MuiTab-root': {
      padding: '6px 16px',
      minHeight: 'auto',
      ...theme.typography.button,
    },
    '& .MuiTab-root.Mui-selected': {
      color: activeTextColor,
      backgroundColor: activeTabColor,
    },
    '& .MuiTab-root:not(.Mui-selected)': {
      color: tabTextColor,
      backgroundColor: tabColor,
    },
    '& .MuiTab-root:not(:last-of-type)': {
      marginRight: theme.spacing(1),
      [theme.breakpoints.up('tablet')]: {
        marginRight: theme.spacing(1),
      },
    },
    '& .MuiTabs-scrollButtons': {
      position: 'absolute',
      width: '24px',
      height: '36px',
      color: '#837300',
      backgroundColor: '#FDFACA',
      borderRadius: '0',
      zIndex: 10,
      ':last-child': {
        right: 0,
      },
    },
  })),
  Tab: styled(Tab)(() => ({
    '&.MuiTab-root': {
      borderRadius: '8px 8px 0 0',
    },
  })),
  ActionsButton: styled(Button)(({ theme }) => ({
    width: '48%',
    color: theme.palette.grey[800],
    backgroundColor: theme.palette.primary.main,
    ':hover': {
      backgroundColor: theme.palette.primary.main,
    },
    ':disabled': {
      color: '#919EABCC',
      backgroundColor: '#DBDEE1',
    },
  })),
};
